// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ContentBlock_root_1daDF{background:#fff;border-radius:10px;padding:32px;box-shadow:0 10px 25px rgba(0,0,0,.15);border:1px solid #eef2f7}", ""]);
// Exports
exports.locals = {
	"root": "ContentBlock_root_1daDF"
};
module.exports = exports;
